import React, { Component } from "react";
import PropTypes from "prop-types";
import "./toast.css";
import Toast from "react-bootstrap/Toast";
import $ from "jquery";

class ToastNotifcation extends Component {
  componentDidMount() {
    $(window).scroll(function () {
      var $el = $(".toast-wrapper");
      var isPositionFixed = $el.css("position") == "fixed";
      if ($(this).scrollTop() > 200 && !isPositionFixed) {
        $el.css({ position: "fixed", top: "0px", right: "20px" });
      }
      if ($(this).scrollTop() < 200 && isPositionFixed) {
        $el.css({ position: "static", top: "0px", right: "20px" });
      }
    });
  }

  render() {
    return (
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: "relative",
        }}
      >
        <div className="toast-wrapper">
          <Toast
            show={this.props.showToast}
            // show={true}
            onClose={() => {
              this.props.closeToast();
            }}
            className={`toast ${
              this.props.toastResult === false ? "error-toast" : "success-toast"
            }
            `}
            autohide
          >
            <Toast.Header closeButton={false} // Disable default close button
        style={{ position: "relative" }}>
          <button
          type="button"
          style={{
            position: "absolute",
            right: "10px",
            top: "",
            // backgroundColor: "white",
            // borderRadius: "50%",
            width: "20px",
            height: "20px",
            border: "none",
            color: "black",
            cursor: "pointer",
          }}
          onClick={() => {
              this.props.closeToast();
            }}
        >
          ×
        </button>
        </Toast.Header>
            <Toast.Body>
              <strong>{`${
                this.props.toastResult ? "Sucess" : "Failed"
              }! `}</strong>
              {this.props.toastMessage}
            </Toast.Body>
          </Toast>
        </div>
      </div>
    );
  }
}

ToastNotifcation.propTypes = {
  showToast: PropTypes.bool,
  closeToast: PropTypes.func,
  toastResult: PropTypes.string,
  toastMessage: PropTypes.string,
};

export default ToastNotifcation;
